import React, { useEffect, useState } from "react";
import { MainLayout } from "../../../layout/MainLayout";
import { useParams } from "react-router";
import Switch from '@mui/material/Switch';
import { Grid } from "../../../UI/Grid";
import { TabList } from "../../../UI/TabList";
import { Tab } from "../../../UI/Tab";
import { TabPanel } from "../../../UI/TabPanel";
import { Tabs } from "../../../UI/Tabs";
import { Typography } from "../../../UI/Typography";
import { PortfolioNetworkTemplateTab } from "./PortfolioNetworkTemplateTab";
import { PortfolioNetworkIntegrationTab } from "./PortfolioNetworkIntegrationTab";
import { useGetBreadcrumbs } from './sharedElements';
import useAuth from "../../login/AuthContext";
import {
  LoadPortfolio,
  Portfolio
} from "../../../services/PortfolioApi";

interface PortfolioNetworkDetailsProps {
  
}

export const PortfolioNetworkDetails: React.FC<PortfolioNetworkDetailsProps> = () => {
  const { getAuthToken } = useAuth();
  const [network, setNetwork] = useState<any>();
  const [portfolio, setPortfolio] = useState<Portfolio>();
  const [ showArchived, setShowArchived ] = useState<boolean>(false);
  const { portfolioId, networkId } = useParams<{ portfolioId: string, networkId: string }>();
  const endAdornment = useGetBreadcrumbs(portfolio, network);

  useEffect(() => {
    const load = async () => {
      let portfolioRequest = await LoadPortfolio(portfolioId, await getAuthToken());

      if (portfolioRequest) {
        setPortfolio(portfolioRequest);

        const currentNetwork = portfolioRequest.networks.find(network => network.l1Id === Number(networkId));

        if (currentNetwork) {
          setNetwork(currentNetwork);
        }
      };
    };
    load();
  }, [portfolioId]);

  const handleTogglChange = (_: any, checked: boolean) =>setShowArchived(checked);

  return (
    <MainLayout
      title="Portfolios"
      subtitle={network ? `${networkId} ${network.name}` : ' '}
      endAdornment={network ? endAdornment : null}
      subEndAdornment={
        <Grid container justifyContent="flex-end" alignItems="center" pr={5}>
          <Typography> Show Archived
            <Switch value={showArchived} onChange={handleTogglChange}/>
          </Typography>
        </Grid>
      }
    >
      <Tabs id={"portfolioNetworkTabs"}>
        <TabList>
          <Tab>Templates</Tab>
          <Tab>Integration</Tab>
        </TabList>
        <TabPanel>
          <PortfolioNetworkTemplateTab portfolioId={portfolioId} showArchived={showArchived}/>
        </TabPanel>
        <TabPanel>
          <PortfolioNetworkIntegrationTab portfolioId={portfolioId} networkId={networkId} />
        </TabPanel>
      </Tabs>
    </MainLayout>
  );
};

export const PORTFOLIO_NETWORK_DETAILED = "/super_admin/portfolios/:portfolioId/networks/:networkId";